import { ChangeDetectionStrategy, ChangeDetectorRef, AfterViewInit, Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BooleanInput } from '@angular/cdk/coercion';
import { Observable, Subject, take, takeUntil,tap,map, windowWhen} from 'rxjs';
import { User } from 'app/core/user/user.types';
import { UserService } from 'app/core/user/user.service';
import { RoleService } from 'app/modules/admin/user-management/services/role.service';
import { AuthService, ImpersonationState } from 'app/core/auth/auth.service';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { FuseConfirmationService } from '@fuse/services/confirmation';

@Component({
    selector       : 'user',
    templateUrl    : './user.component.html',
    encapsulation  : ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs       : 'user'
})
export class UserComponent implements OnInit, OnDestroy,AfterViewInit
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_showAvatar: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() showAvatar: boolean = true;
    user: User;
    impersonation: ImpersonationState | null = null;
    stoppingImpersonation: boolean = false;

    private _unsubscribeAll: Subject<any> = new Subject<any>();
    public rolesOptions$:Observable<any> = new Observable();
    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _router: Router,
        private _userService: UserService,
        private _roleService:RoleService,
        private _authService: AuthService,
        private _navigationService: NavigationService,
        private _fuseConfirmationService: FuseConfirmationService
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void
    {

        // Subscribe to user changes
        this._userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;

                // Mark for check
                this._changeDetectorRef.markForCheck();

            });

        this._authService.impersonation$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((impersonation) => {
                this.impersonation = impersonation;
                this._changeDetectorRef.markForCheck();
            });

    }

    public changeRol(id:number,role_id:number){
        this._roleService.changeCurrentRole(role_id).subscribe({
            complete:()=>{

                window.location.href = "/";
                //this._router.navigateByUrl('/');
                //window.location.reload();
            }
        });

    }

    ngAfterViewInit(): void {
        //dont delete both change detectors
        this._changeDetectorRef.markForCheck();
        setTimeout(() => {
            // Mark for check
            this._changeDetectorRef.markForCheck();
            this.rolesOptions$ = this._roleService.getRoleByUserId()
                    .pipe(
                        map(value=>{

                            return value.roles_associated;
                        })
                    );
        }, 0);
    }
    /**
     * On destroy
     */
    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Update the user status
     *
     * @param status
     */
    updateUserStatus(status: string): void
    {
        // Return if user is not available
        if ( !this.user )
        {
            return;
        }

        // Update the user
        this._userService.update({
            ...this.user,
            status
        }).subscribe();
    }

    /**
     * Sign out
     */
    signOut(): void
    {
        this._router.navigate(['/sign-out']);
    }

    stopImpersonation(): void
    {
        if ( !this.impersonation?.active || this.stoppingImpersonation )
        {
            return;
        }

        this.stoppingImpersonation = true;
        this._changeDetectorRef.markForCheck();

        this._authService.stopImpersonation().subscribe({
            next: () => {
                this._navigationService.get().pipe(take(1)).subscribe({
                    complete: () => this._finishStopImpersonation(),
                    error: () => this._finishStopImpersonation()
                });
            },
            error: () => {
                this.stoppingImpersonation = false;
                this._changeDetectorRef.markForCheck();
                this._fuseConfirmationService.open({
                    title: 'Error al detener impersonacion',
                    message: 'No se pudo detener la impersonacion. Intente nuevamente.',
                    icon: {
                        show: true,
                        name: 'heroicons_outline:exclamation',
                        color: 'error'
                    },
                    actions: {
                        confirm: {
                            label: 'Aceptar',
                            color: 'primary'
                        },
                        cancel: {
                            show: false
                        }
                    }
                });
            }
        });
    }

    /**
     * User profile
     */
     showUserProfile(): void
     {
         this._router.navigate(['/user-profile']);
     }

     private _finishStopImpersonation(): void
     {
         this.stoppingImpersonation = false;
         this._changeDetectorRef.markForCheck();
         this._router.navigateByUrl('/apps/home');
     }
}
